import restrictedWords from './restricted_words.json';

// Merge, dedupe, sort
const RESTRICTED_WORD_LIST: string[] = Array.from(
  new Set([
    ...restrictedWords.standard_words,
    ...restrictedWords.bad_words
  ])
).sort((a, b) =>
  a.localeCompare(b, 'en', { numeric: true })
);

export default RESTRICTED_WORD_LIST;